import React, { useState } from 'react';
import { Category } from '@/types/category';
import { Link } from 'react-router-dom';

interface SidebarProps {
  categories: Category[];
  onCategorySelect: (categoryId: number) => void;
  selectedCategory: number | null;
}

const Sidebar: React.FC<SidebarProps> = ({ categories, onCategorySelect, selectedCategory }) => {
  const [expandedCategories, setExpandedCategories] = useState<number[]>([]);

  // Функция для получения подкатегорий
  const getSubcategories = (parentId: number) => {
    return categories.filter(category => category.parent === parentId);
  };

  // Функция для проверки наличия подкатегорий
  const hasSubcategories = (categoryId: number) => {
    return categories.some(category => category.parent === categoryId);
  };

  // Функция для переключения состояния раскрытия категории
  const toggleCategory = (categoryId: number, event: React.MouseEvent) => {
    event.stopPropagation();
    setExpandedCategories(prev =>
      prev.includes(categoryId)
        ? prev.filter(id => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  // Обновленная функция для обработки выбора категории
  const handleCategorySelect = (categoryId: number) => {
    onCategorySelect(categoryId);
  };

  // Получаем основные категории (без родителей)
  const mainCategories = categories.filter(category => category.parent === 0);

  return (
    <div className="w-full md:w-64 bg-[#FEC80A] p-4 rounded-lg shadow-md h-fit">
      <h2 className="text-xl font-bold mb-4 text-gray-800">Categories</h2>
      <ul className="space-y-2">
        {mainCategories.map(category => (
          <li key={category.id}>
            <div className="flex items-center">
              <Link
                to={`/catalog/${category.slug}`}
                onClick={() => handleCategorySelect(category.id)}
                className={`flex-grow text-left p-2 rounded hover:bg-gray-100 ${
                  selectedCategory === category.id ? 'bg-yellow-400 text-white hover:bg-yellow-500' : ''
                }`}
              >
                {category.name}
              </Link>
              {hasSubcategories(category.id) && (
                <button
                  onClick={(e) => toggleCategory(category.id, e)}
                  className="px-2 py-1 ml-2 text-black hover:text-gray-600 cursor-pointer font-bold text-xl"
                >
                  {expandedCategories.includes(category.id) ? '−' : '+'}
                </button>
              )}
            </div>
            {expandedCategories.includes(category.id) && (
              <ul className="ml-4 mt-2 space-y-2">
                {getSubcategories(category.id).map(subCategory => (
                  <li key={subCategory.id}>
                    <div className="flex items-center">
                      <Link
                        to={`/catalog/${subCategory.slug}`}
                        onClick={() => handleCategorySelect(subCategory.id)}
                        className={`flex-grow text-left p-2 rounded hover:bg-gray-100 ${
                          selectedCategory === subCategory.id ? 'bg-yellow-400 text-white hover:bg-yellow-500' : ''
                        }`}
                      >
                        {subCategory.name}
                      </Link>
                      {hasSubcategories(subCategory.id) && (
                        <button
                          onClick={(e) => toggleCategory(subCategory.id, e)}
                          className="px-2 py-1 ml-2 text-yellow-400 hover:text-yellow-500 font-bold text-xl"
                        >
                          {expandedCategories.includes(subCategory.id) ? '−' : '+'}
                        </button>
                      )}
                    </div>
                    {expandedCategories.includes(subCategory.id) && (
                      <ul className="ml-4 mt-2 space-y-2">
                        {getSubcategories(subCategory.id).map(subSubCategory => (
                          <li key={subSubCategory.id}>
                            <Link
                              to={`/catalog/${subSubCategory.slug}`}
                              onClick={() => handleCategorySelect(subSubCategory.id)}
                              className={`w-full text-left p-2 rounded hover:bg-gray-100 ${
                                selectedCategory === subSubCategory.id ? 'bg-yellow-400 text-white hover:bg-yellow-500' : ''
                              }`}
                            >
                              {subSubCategory.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar; 